module.exports = __webpack_public_path__ + "static/img/box LCL@3x.5e9474d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/instantprice/box LCL@3x.png
// module id = i7/0
// module chunks = 0